import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Icon } from '@millionshow/client-libs';
import { KakaoLoaderService } from '../../services/kakao-loader.service';

declare const kakao: any;

const VENUE = {
  name: '김대중컨벤션센터',
  address: '광주광역시 서구 상무누리로 30',
  phone: '062-611-2000',
  lat: 35.1496,
  lng: 126.8497,
};

@Component({
  selector: 'app-directions-page',
  imports: [CommonModule, Icon],
  templateUrl: './directions.page.html',
})
export default class DirectionsPage implements OnInit {
  private readonly kakaoLoader = inject(KakaoLoaderService);

  venue = VENUE;

  private map: any;

  ngOnInit(): void {
    setTimeout(() => this.initMap(), 300);
  }

  private async initMap(): Promise<void> {
    await this.kakaoLoader.load();

    const container = document.getElementById('kakao-map-directions');
    if (!container) return;

    const coords = new kakao.maps.LatLng(VENUE.lat, VENUE.lng);

    this.map = new kakao.maps.Map(container, {
      center: coords,
      level: 4,
    });

    const marker = new kakao.maps.Marker({
      map: this.map,
      position: coords,
    });

    const infowindow = new kakao.maps.InfoWindow({
      content: `
        <div style="
          font-size: 13px;
          font-weight: 600;
          text-align: center;
          padding: 8px 12px;
          min-width: 140px;
        ">${VENUE.name}</div>
      `,
    });

    infowindow.open(this.map, marker);
  }

  openKakaoMapDirections(): void {
    const name = encodeURIComponent(VENUE.name);
    window.open(
      `https://map.kakao.com/link/to/${name},${VENUE.lat},${VENUE.lng}`,
      '_blank'
    );
  }

  openKakaoMapDetail(): void {
    const name = encodeURIComponent(VENUE.name);
    window.open(`https://map.kakao.com/link/search/${name}`, '_blank');
  }
}
